module.exports = __webpack_public_path__ + "img/logo.94f459e4.png";